module.exports = __webpack_public_path__ + "img/r2.d7b6fdee.png";